export enum StorageModeEnum {
  ON = "on",
  OFF = "off"
}

export enum PresenceMessageEnum {
  PING = "ping",
  PONG = "pong"
}

export type TabRegistry = Record<string, number>;

export type MigrationLock = { ts: number; owner: string };

export type PresenceMessage =
  | { type: PresenceMessageEnum.PING; requestId: string }
  | { type: PresenceMessageEnum.PONG; requestId: string; from: string };

export interface AsyncStorage {
  getItem<T = unknown>(key: string): Promise<T | null>;
  setItem<T = unknown>(key: string, value: T): Promise<T>;
  removeItem(key: string): Promise<void>;
}
